var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18h6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22v-4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2v1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8a4 4 0 0 0 0 8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8a4 4 0 0 1 0 8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16v.01"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.25c0-1.79 1.34-3.25 3-3.25s3 1.46 3 3.25c0 1.24-.57 2.32-1.41 2.85C12.96 9.5 12 10.69 12 12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQa);
export default __webpack_public_path__ + "static/media/icon-qa.75e05a9f31a137ed4de73c0fc4fea099.svg";
export { ForwardRef as ReactComponent };